<template>
  <Flex :class="{ 'router-link-exact-active': isCurrentSeries($route.query.selectedSeries) }">
    <Flex :class="{ 'cursor-pointer': true }">
      <router-link class="category-link" :to="getRoute(series, selectedSubOption)">
        {{ series.name }}
      </router-link>
    </Flex>
    <DropDown :options="series.subOptions" @updateOption="onSubOptionUpdate" />
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import { isEqual } from 'lodash'
import DropDown from '@/components/DropDown'

export default {
  name: 'SeriesSelector',
  components: {
    DropDown,
    Flex,
  },
  props: {
    series: Object,
  },
  data() {
    return {
      showMenu: false,
      selectedSubOption: this.series.subOptions[0],
    }
  },
  methods: {
    onSubOptionUpdate(newSubOption) {
      this.selectedSubOption = newSubOption
      const route = this.getRoute(this.series, this.selectedSubOption)
      if (!isEqual(this.$route.query, route.query)) {
        this.$router.push(route)
      }
    },
    getRoute(series, subOption) {
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          selectedSeries: series.attributePath,
        },
      }
      if (subOption) {
        // The only subOption value for series we currently support is level
        route.query[`series${subOption.attributeName}`] = subOption.attributeValue
      }
      return route
    },
    isCurrentSeries(series) {
      return series === this.series.attributePath
    },
  },
}
</script>

<style lang="postcss" scoped>
.category-link {
  @apply break-words;
}
</style>
